import { fetchStageMenuByDay } from './ajax.js';
import { stageMenuStore } from './store.js';
import { loadTemplate } from '../../template/index.js';
import { handleClick } from './handlers.js';
import { displayFieldList, triggerStageMenuReload, updateRecipeCounter } from './render.js';

let stageContainer = null;
let currentStageId = null;

/**
 * Initialize stage menu recipes
 * Sets up event listeners and loads initial data
 */
export async function initStageMenus() {
	stageContainer = document.getElementById('recipe');
	if (!stageContainer) return;

	const editStageTab = stageContainer.closest('.edit-stage-tab');
	if (!editStageTab) return;

	const stageVideosContainer = editStageTab.querySelector('.stage-videos');
	currentStageId = stageVideosContainer?.getAttribute('data-stage-id');
	if (!currentStageId) return;

	stageMenuStore.setStageId(currentStageId);

	// Listen for reload event
	document.addEventListener('stage-menu-reload', reloadCurrentDay);

	// Event delegation for delete and add buttons
	stageContainer.addEventListener('click', handleClick);

	// Load templates once
	await Promise.all([
		loadTemplate('stage/recipe/item.ejs'),
		loadTemplate('stage/recipe/empty.ejs'),
		loadTemplate('stage/recipe/list-title.ejs'),
		loadTemplate('stage/recipe/select-item.ejs'),
	]);

	// Load all 7 days in parallel
	await Promise.all(
		Array.from({ length: 7 }, (_, i) => loadDay(i + 1))
	);

	// Update counter after initial load
	updateRecipeCounter();
}

/**
 * Load and display all category recipes for a specific day
 * @param {number} day - Day number (1-7)
 */
async function loadDay(day) {
	const dayContainer = stageContainer.querySelector(`#day_${day}`);
	if (!dayContainer) return;

	const categories = await fetchStageMenuByDay(currentStageId, day);
	stageMenuStore.setDayCategories(day, categories);

	// Render recipes into each category container
	renderDayRecipes(dayContainer);
}

/**
 * Render recipes into category containers for a day
 * @param {HTMLElement} dayContainer - The day tab container
 */
function renderDayRecipes(dayContainer) {
	const recipeContainers = dayContainer.querySelectorAll('.recipe-list[data-field-name]');
	recipeContainers.forEach(container => {
		const fieldName = container.getAttribute('data-field-name');
		displayFieldList(container, fieldName);
	});
}

/**
 * Reload a specific day's recipes
 * @param {CustomEvent} e - Event with day in detail
 */
async function reloadCurrentDay(e) {
	const day = e.detail?.day;
	if (!day) return;

	await loadDay(day);
	updateRecipeCounter();
}

export { triggerStageMenuReload };
